// extracted by mini-css-extract-plugin
export var spinner = "LoadingSpinner-module--spinner--1fyx0";
export var spin = "LoadingSpinner-module--spin--2-zig";